import React, { useEffect, useState, useRef, useMemo } from "react"
import "./CloudCodePanel.scss"

const AwsExample = () => (
  <>
    <div key="aws" className="code-section">
      <div className="code -aws">
        <p className="comment">#imports</p>
        <p>
          <span className="imports">from</span> braket.
          <span className="method">circuits</span>{" "}
          <span className="imports">import</span> Circuit
        </p>
        <p>
          <span className="imports">from</span> braket.
          <span className="method">aws</span>{" "}
          <span className="imports">import</span> AwsDevice
        </p>
        <p>
          <br />
        </p>
        <p className="comment">#hello many worlds</p>
        <p>
          circ <span className="operator">=</span> Circuit()
        </p>
        <p>
          circ.<span className="method">h</span>(
          <span className="number">1</span>)
        </p>
        <p>
          circ.<span className="method">cnot</span>(control
          <span className="operator">=</span>
          <span className="number">1</span>, target
          <span className="operator">=</span>
          <span className="number">0</span>)
        </p>
        <p>
          <br />
        </p>
        <p className="comment">#run on IonQ hardware</p>
        <p>
          ionq <span className="operator">=</span> AwsDevice(
          <span className="string">
            "arn:aws:braket:::device/qpu/ionq/ionQdevice"
          </span>
          )
        </p>
        <p>
          job <span className="operator">=</span> ionq.
          <span className="method">run</span>(circ, (
          <span className="string">"my_s3_bucket"</span>,
          <span className="string">"my_s3_folder"</span>), shots
          <span className="operator">=</span>
          <span className="number">100</span>)
        </p>
        <p>
          <span className="builtin">print</span>(job.
          <span className="method">result</span>().
          <span className="method">measurement_counts</span>)
        </p>
      </div>
    </div>
    <div className="results -aws">
      <pre>$ python3 braket_example.py</pre>
      <pre>{`Counter( {'00': 49, '11': 51} )`}</pre>
    </div>
  </>
)

const AzureExample = () => (
  <>
    <div key="azure" className="code-section">
      <div className="code -azure">
        <pre>
          <span className="method">namespace</span>{" "}
          <span className="imports">HelloManyWorlds</span> {`{`}
        </pre>
        <pre>
          {" "}
          <span className="method">open</span> Microsoft.Quantum.Intrinsic;
        </pre>
        <pre>
          {" "}
          <span className="method">open</span> Microsoft.Quantum.Measurement;
        </pre>
        <pre> @EntryPoint()</pre>
        <pre>
          {" "}
          <span className="method">operation</span> CreateBellPair() :{" "}
          <span className="method">Result</span>[] {`{`}
        </pre>
        <pre>
          {" "}
          use qubits <span className="operator">=</span>{" "}
          <span className="method">Qubit</span>[
          <span className="number">2</span>];
        </pre>
        <pre>
          {" "}
          <span className="string">H</span>(qubits[
          <span className="number">1</span>]);
        </pre>
        <pre>
          {" "}
          <span className="string">CNOT</span>(qubits[
          <span className="number">1</span>], qubits[
          <span className="number">0</span>]);
        </pre>
        <pre>
          {" "}
          <span className="builtin">return</span>{" "}
          <span className="string">MultiM</span>(qubits);
        </pre>
        <pre> {`}`}</pre>
        <pre>{`}`}</pre>
      </div>
      <div className="results -azure">
        <pre>
          $ az quantum execute --target-id ionq.qpu --shots 100 -o table
        </pre>
        <pre> </pre>
        <pre>Result Frequency</pre>
        <pre>-------- ----------- -------------------------</pre>
        <pre>[0,0] 0.49000000 ████████████ |</pre>
        <pre>[1,1] 0.51000000 █████████████ |</pre>
      </div>
    </div>
  </>
)

const QiskitExample = () => (
  <>
    <div className="code-section">
      <div className="code -qiskit">
        <p className="comment">#imports</p>
        <p>
          <span className="imports">from</span> qiskit_ionq{" "}
          <span className="imports">import</span>{" "}
          <span className="method">IonQProvider</span>
        </p>
        <p>
          <span className="imports">from</span> qiskit{" "}
          <span className="imports">import</span>{" "}
          <span className="method">QuantumCircuit</span>
        </p>
        <p>
          <br />
        </p>
        <p className="comment">#hello many worlds</p>
        <p>
          qc <span className="operator">=</span> QuantumCircuit(
          <span className="number">2</span>, <span className="number">2</span>)
        </p>
        <p>
          qc.<span className="method">h</span>(<span className="number">0</span>
          )
        </p>
        <p>
          qc.<span className="method">cx</span>(
          <span className="number">0</span>, <span className="number">1</span>)
        </p>
        <p>
          qc.<span className="method">measure</span>([
          <span className="number">0</span>, <span className="number">1</span>
          ],[<span className="number">0</span>,{" "}
          <span className="number">1</span>])
        </p>
        <p>
          <br />
        </p>
        <p className="comment">#run on IonQ hardware</p>
        <p>
          ionq <span className="operator">=</span> provider.
          <span className="method">get_backend</span>(
          <span className="string">"ionq_simulator"</span>)
        </p>
        <p>
          job <span className="operator">=</span> ionq.
          <span className="method">run</span>(qc, shots
          <span className="operator">=</span>
          <span className="number">100</span>)
        </p>
        <p>
          <span className="builtin">print</span>(job.
          <span className="method">get_counts</span>())
        </p>
      </div>
    </div>
    <div className="results -qiskit">
      <pre>$ python3 qiskit_example.py</pre>
      <pre>{`{'00': 49, '11': 51}`}</pre>
    </div>
  </>
)

const CirqExample = () => (
  <>
    <div className="code-section">
      <div className="code -cirq">
        <p className="comment">#imports</p>
        <p>
          <span className="imports">import</span> cirq
        </p>
        <p>
          <span className="imports">import</span> cirq.ionq{" "}
          <span className="imports">as</span>{" "}
          <span className="method">ionq</span>
        </p>
        <p>
          <br />
        </p>
        <p className="comment">#hello many worlds</p>
        <p>
          q0, q1 = cirq.<span className="method">LineQubit</span>.range(
          <span className="number">2</span>)
        </p>
        <p>
          circuit = cirq.<span className="method">Circuit</span>()
        </p>
        <p>
          circuit.<span className="method">append</span>(
        </p>
        <pre>
          {" "}
          [cirq.<span className="method">H</span>(q0), cirq.
          <span className="method">CNOT</span>(q0, q1), cirq.
          <span className="method">measure</span>(q0, q1, key
          <span className="operator">=</span>
          <span className="string">"x"</span>)]
        </pre>
        <p>)</p>
        <p>
          <br />
        </p>
        <p className="comment">#run on IonQ hardware</p>
        <p>
          service <span className="operator">=</span> ionq.
          <span className="method">Service</span>(api_key
          <span className="operator">=</span>
          <span className="string">"api-key"</span>, default_target
          <span className="operator">=</span>
          <span className="string">"qpu"</span>)
        </p>
        <p>
          job <span className="operator">=</span> service.
          <span className="method">run</span>(circuit
          <span className="operator">=</span>circuit, repetitions
          <span className="operator">=</span>
          <span className="number">100</span>)
        </p>
        <p>
          print(job.histogram(key<span className="operator">=</span>
          <span className="string">"x"</span>))
        </p>
      </div>
    </div>
    <div className="results -cirq">
      <pre>$ python3 cirq_example.py</pre>
      <pre>{`Count({3: 51, 0: 49})`}</pre>
    </div>
  </>
)

const CloudCodePanel = () => {
  const [panelOrder, updatePanelOrder] = useState([])
  const [activePanel, setActivePanel] = useState("aws")
  const [runCarousel, setRunCarousel] = useState(true)
  const switchTimeout = useRef()
  useEffect(() => {
    const order = ["aws", "azure", "cirq", "qiskit"]
    const firstPanel = new Date().getHours() % order.length
    const spliced = order.splice(0, firstPanel)
    order.push(...spliced)
    updatePanelOrder(order)
    setActivePanel(order[0])
  }, [])

  const panels = useMemo(
    () => ({
      aws: {
        tab: (
          <button
            key="aws"
            className={`tab${activePanel === "aws" ? " -active" : ""}`}
            onClick={() => {
              changePanel("aws")
            }}
          >
            aws_example.py
          </button>
        ),
        panel: <AwsExample key="aws" />,
        nextPanel: "azure",
      },
      azure: {
        tab: (
          <button
            key="azure"
            className={`tab${activePanel === "azure" ? " -active" : ""}`}
            onClick={() => {
              changePanel("azure")
            }}
          >
            azure_example.qs
          </button>
        ),
        panel: <AzureExample key="azure" />,
        nextPanel: "cirq",
      },
      cirq: {
        tab: (
          <button
            key="cirq"
            className={`tab${activePanel === "cirq" ? " -active" : ""}`}
            onClick={() => {
              changePanel("cirq")
            }}
          >
            cirq_example.py
          </button>
        ),
        panel: <CirqExample key="cirq" />,
        nextPanel: "qiskit",
      },
      qiskit: {
        tab: (
          <button
            key="qiskit"
            className={`tab${activePanel === "qiskit" ? " -active" : ""}`}
            onClick={() => {
              changePanel("qiskit")
            }}
          >
            qiskit_example.py
          </button>
        ),
        panel: <QiskitExample key="qiskit" />,
        nextPanel: "aws",
      },
    }),
    [activePanel]
  )

  const nextPanel = useRef(panels[activePanel].nextPanel)
  const changePanel = panel => {
    setActivePanel(panel)
    setRunCarousel(false) //stop the carousel if user clicks a tab
  }
  useEffect(() => {
    clearTimeout(switchTimeout.current)
    nextPanel.current = panels[activePanel].nextPanel
    if (runCarousel) {
      switchTimeout.current = setTimeout(() => {
        setActivePanel(nextPanel.current)
      }, 8000)
    }
  }, [activePanel, panels, runCarousel])

  return (
    <div className="CloudCodePanel">
      <div className="tab-bar">
        <div className="buttons" aria-hidden>
          <span className="button"></span>
          <span className="button"></span>
          <span className="button"></span>
        </div>
        <div className="tabs">{panelOrder.map(panel => panels[panel].tab)}</div>
      </div>
      {panels[activePanel].panel}
    </div>
  )
}

export default CloudCodePanel
